import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Container, Row, Col, Spacer } from '@cleartrip/bento/lib';
import Sandbox from '@components/Sandbox';
import ColorTable from './color.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "color"
    }}>{`Color`}</h1>
    <p>{`Color variables to use inplace of hardcoded values`}</p>
    <h2 {...{
      "id": "primary-palette"
    }}>{`Primary palette`}</h2>
    <ColorTable palette="primary" mdxType="ColorTable" />
    <Spacer my={6} mdxType="Spacer" />
    <h2 {...{
      "id": "secondary-palette"
    }}>{`Secondary palette`}</h2>
    <ColorTable palette="secondary" mdxType="ColorTable" />
    <Spacer my={6} mdxType="Spacer" />
    <h2 {...{
      "id": "tertiary-palette"
    }}>{`Tertiary palette`}</h2>
    <ColorTable palette="tertiary" mdxType="ColorTable" />
    <Spacer my={6} mdxType="Spacer" />
    <h2 {...{
      "id": "success-palette"
    }}>{`Success palette`}</h2>
    <ColorTable palette="success" mdxType="ColorTable" />
    <Spacer my={6} mdxType="Spacer" />
    <h2 {...{
      "id": "warning-palette"
    }}>{`Warning palette`}</h2>
    <ColorTable palette="warning" mdxType="ColorTable" />
    <Spacer my={6} mdxType="Spacer" />
    <h2 {...{
      "id": "error-palette"
    }}>{`Error palette`}</h2>
    <ColorTable palette="error" mdxType="ColorTable" />
    <Spacer my={6} mdxType="Spacer" />
    <h2 {...{
      "id": "neutral-palette"
    }}>{`Neutral palette`}</h2>
    <ColorTable palette="neutral" mdxType="ColorTable" />
    <Spacer my={6} mdxType="Spacer" />
    <h2 {...{
      "id": "text-color"
    }}>{`Text color`}</h2>
    <p>{`Text colour classes take on the syntax of `}<inlineCode parentName="p">{`.c-{palette}-{shade}`}</inlineCode>{`.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <p className="c-secondary-500 m-0">
      The quick brown fox jumped over the lazy dog
    </p>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="c-secondary-500">...</p>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={6} mdxType="Spacer" />
    <h2 {...{
      "id": "background-colour"
    }}>{`Background colour`}</h2>
    <p>{`Similar to text colours, background classes take on the syntax of `}<inlineCode parentName="p">{`.bg-{palette}-{shade}`}</inlineCode>{`.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <button className="button bs-solid bw-1 br-4 lh-solid box-border h-9 fs-body-2 px-4 py-2 bg-primary-500 c-white c-pointer bc-transparent">
      Button
    </button>
  </Sandbox.Preview>
  <Sandbox.Code>
    <button className="bg-primary-500">...</button>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={24} mdxType="Spacer" />
    <h2 {...{
      "id": "border-colour"
    }}>{`Border colour`}</h2>
    <p>{`Border colours also take take on the syntax of `}<inlineCode parentName="p">{`.bc-{palette}-{shade}`}</inlineCode>{`.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <button className="button bs-solid bw-1 br-4 lh-solid box-border h-9 fs-body-2 px-4 py-2 bg-transparent c-primary-500 c-pointer bc-primary-500">
      Button
    </button>
  </Sandbox.Preview>
  <Sandbox.Code>
    <button className="bc-primary-500">...</button>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={24} mdxType="Spacer" />
    <h2 {...{
      "id": "hoverable"
    }}>{`Hoverable`}</h2>
    <p>{`All color classes support a `}<inlineCode parentName="p">{`hover:`}</inlineCode>{` modifier. The syntax is `}<inlineCode parentName="p">{`.hover:bg-{palette}-{shade}`}</inlineCode>{`.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <p className="c-secondary-500 hover:c-primary-500 m-0 c-pointer">
      The quick brown fox jumped over the lazy dog
    </p>
  </Sandbox.Preview>
  <Spacer my={2} mdxType="Spacer" />
  <Sandbox.Preview>
    <button className="button bc-transparent br-4 lh-solid box-border h-9 fs-body-2 px-4 py-2 bg-transparent c-white bg-primary-500 hover:bg-primary-600 c-pointer">
      Button
    </button>
  </Sandbox.Preview>
  <Spacer my={2} mdxType="Spacer" />
  <Sandbox.Preview>
      <button className="button bs-solid bw-1 br-4 lh-solid box-border h-9 fs-body-2 px-4 py-2 bg-transparent c-primary-500 hover:c-primary-800 c-pointer bc-primary-500 hover:bc-primary-800">
        Button
      </button>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="c-secondary-500 hover:c-primary-500">...</p>
    <button className="bg-primary-500 hover:bg-primary-600">...</button>
    <button className="bc-primary-500 hover:bc-primary-800">...</button>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={6} mdxType="Spacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      